import React, { useState } from 'react';
import { Modal, Button, Alert, Form } from 'react-bootstrap';
import { Trash2, AlertTriangle, Package } from 'lucide-react';

const DeleteConfirmModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  product,
  loading = false 
}) => {
  
  const [confirmText, setConfirmText] = useState('');
  const [understood, setUnderstood] = useState(false);
  
  if (!product) return null;

  const isConfirmValid = confirmText.toLowerCase() === 'supprimer' && understood;

  const handleConfirm = () => {
    if (isConfirmValid) {
      onConfirm(product);
    }
  };

  const handleClose = () => {
    setConfirmText('');
    setUnderstood(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="text-danger d-flex align-items-center">
          <AlertTriangle size={24} className="me-2" />
          Confirmer la suppression
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert variant="danger" className="mb-3">
          <strong>⚠️ Action irréversible</strong><br />
          Cette action supprimera définitivement le produit et toutes ses données associées.
        </Alert>

        {/* Informations du produit */}
        <div className="border rounded p-3 mb-3 bg-light">
          <div className="d-flex align-items-center mb-2">
            <Package size={20} className="me-2 text-muted" />
            <strong>{product.name}</strong>
          </div>
          <div className="small text-muted">
            {product.sku && <div>SKU: {product.sku}</div>}
            {product.categoryName && <div>Catégorie: {product.categoryName}</div>}
            <div>Stock actuel: {product.currentStock || product.stock || 0}</div>
          </div>
        </div>

        {/* Conséquences */}
        <div className="mb-3">
          <h6>Cette suppression entraînera :</h6>
          <ul className="small">
            <li>Suppression définitive du produit</li>
            <li>Suppression de l'historique des mouvements de stock</li>
            <li>Suppression de l'image associée</li>
            <li>Le produit ne sera plus disponible pour les ventes</li>
          </ul>
        </div>

        {/* Confirmation par texte */}
        <Form.Group className="mb-3">
          <Form.Label>
            Pour confirmer, tapez <code>supprimer</code> ci-dessous :
          </Form.Label>
          <Form.Control
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="Tapez 'supprimer' pour confirmer"
            disabled={loading}
          />
        </Form.Group>

        {/* Case à cocher de compréhension */}
        <Form.Check
          type="checkbox"
          checked={understood}
          onChange={(e) => setUnderstood(e.target.checked)}
          label="Je comprends que cette action est irréversible"
          disabled={loading}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={handleClose}
          disabled={loading}
        >
          Annuler
        </Button>
        <Button 
          variant="danger" 
          onClick={handleConfirm}
          disabled={!isConfirmValid || loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Suppression...
            </>
          ) : (
            <>
              <Trash2 size={16} className="me-2" />
              Supprimer définitivement
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmModal;